import {
  Button,
  ButtonGroup,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { IoChevronDown } from "react-icons/io5";

/**
 * @typedef {object} MultiButtonAction
 * @property {string} name
 * @property {() => void} execute
 */

/**
 * A component that displays a button with an optionnal menu if the number of actions is greater than 1
 * @typedef {object} Props
 * @property {MultiButtonAction[]} actions
 * @property {import("@chakra-ui/react").ButtonGroupProps} [buttonGroupProps]
 * @property {string} [colorScheme]
 *
 * @param {import("react").PropsWithChildren<Props>} props
 * @return {import("react").FunctionComponentElement<Props>}
 */
function MultiButton({ actions, buttonGroupProps = {}, colorScheme = "red" }) {
  const defaultAction = actions?.[0];

  const otherActions = actions?.slice(1);

  return (
    <Menu placement="bottom-end">
      <ButtonGroup isAttached={true} {...buttonGroupProps}>
        <Button onClick={defaultAction?.execute} colorScheme={colorScheme}>
          {defaultAction?.name}
        </Button>

        {actions?.length > 1 && (
          <MenuButton as={Button} colorScheme={colorScheme}>
            <IoChevronDown />
          </MenuButton>
        )}
      </ButtonGroup>

      <MenuList>
        {otherActions?.map?.((action) => (
          <MenuItem onClick={action.execute} key="index">
            <Text>{action.name}</Text>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}

export default MultiButton;
